export default __webpack_public_path__ + "static/media/634B1CE6-87B2-4F90-B12E-04EA3D9CD092_1_105_c.437bb1fd.jpeg";